export const SET_SELECTED_RESULT = "SET_SELECTED_RESULT";
export const GET_PAGES_REQUEST = "GET_PAGES_REQUEST";
export const GET_PAGES_SUCCESS = "GET_PAGES_SUCCESS";
export const GET_PAGES_FAILED = "GET_PAGES_FAILED";
